import { useContext, useRef } from 'react';
import { PlaceholderImage } from '@shared/assets';
import { IconButton } from '@shared/ui/buttons';
import { useNoteTools } from '../../model/hooks';
import { EditorRefContext } from '../../utils';
import st from './styles.module.scss';

export const AddImgButton: React.FC = () => {
  const { setVisibleTools, switchOpenTools } = useNoteTools();
  const localEditorRef = useContext(EditorRefContext);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const insertImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
    switchOpenTools();
    setVisibleTools(false);
    const file = event.target.files?.[0];

    if (file) {
      console.log(file.type);
      const reader = new FileReader();

      reader.onload = (e) => {
        const range = document.getSelection()?.getRangeAt(0);

        if (range) {
          const parentElement = range?.startContainer.parentElement;
          const grandParentElement = parentElement?.parentElement;

          if (parentElement && parentElement.tagName === 'P') {
            grandParentElement?.removeChild(parentElement);
          } else {
            while (parentElement?.firstChild) {
              parentElement.removeChild(parentElement.firstChild);
            }
          }

          const img = document.createElement('img');
          img.src = e.target?.result as string;
          img.alt = `название изображения ${file.name}`;
          img.style.marginLeft = '40px';
          range.deleteContents();
          range.insertNode(img);

          range.setStartAfter(img);
          range.setEndAfter(img);
          document.getSelection()?.removeAllRanges();
          document.getSelection()?.addRange(range);

          localEditorRef && localEditorRef.current?.focus();
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };
  return (
    <>
      <IconButton variant="white" type="button" onClick={triggerFileInput} className={st.addBtn}>
        <PlaceholderImage />
      </IconButton>
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={insertImage} />
    </>
  );
};
